export default __webpack_public_path__ + "static/media/CWRK.730e5532.Mp4";